import {clsx} from 'clsx'

import styles from './CircleProgressBar.module.css'

export function CircleProgressBar({value}: {value: number}) {
  const exceeded = value > 100

  return (
    <div
      className={clsx(styles.circleProgressBar, exceeded ? styles.exceeded : '')}
      style={{'--progress': `${value}%`}}
    >
      <progress value={value} max="100" style={{visibility: 'hidden', height: 0, width: 0}}>
        {value}%
      </progress>
    </div>
  )
}
